import React, { useEffect, useState } from "react";
import GoogleReviews from "../../images/google-reviews.svg"
import GoogleReviewsColor from "../../images/google-reviews-color.svg"
import "./GoogleRating.scss"
import { useStaticQuery, graphql } from "gatsby";
import axios from "axios"
import wordsToNumbers from 'words-to-numbers';
import { useLocation } from "@reach/router"
const GoogleRating = ({testimonials}) => {
  const [isClient, setClient] = useState(false);

  const [renderComponent, setRenderComponent] = useState(false);
  let location = useLocation();
  let review = '';
  let revclass = '';
  if ( location.pathname.includes('/property-valuation')) {
    review = 'true';
    revclass = 'textblack';
  }
  React.useEffect(() => {
    window.addEventListener("mousemove", () => {
      if (renderComponent === false) {
        setRenderComponent(true)
      }
      })
      window.addEventListener("touchmove", () => {
          if (renderComponent === false) {
          setRenderComponent(true)
          }
      })
      window.addEventListener("keypress", () => {
          if (renderComponent === false) {
          setRenderComponent(true)
          }
      })      
  }, [])

  useEffect(() => {
    setClient(true);
  }, [])

  var testimonial_count = testimonials ? testimonials.length : 0;
  var rating_count = 0;
  testimonials && testimonials.length > 0 && testimonials.map((item, ind) => {
    rating_count += parseInt(wordsToNumbers(item.starRating));
  })
  var rating_avg = rating_count / testimonial_count;
  const latestReviewsScore = useStaticQuery(graphql`
        query {
            allStrapiGoogleReviewReviews {
                edges {
                    node {
                        id
                        starRating
                    }
                },
                pageInfo {
                    totalCount
                }
            }
        }
    `)
  const reviews = latestReviewsScore.allStrapiGoogleReviewReviews.edges;
  const reviewsCount = latestReviewsScore.allStrapiGoogleReviewReviews.pageInfo.totalCount;
  const wordToNumber = { 'ONE': 1, 'TWO': 2, 'THREE': 3, 'FOUR': 4, 'FIVE': 5 };
  let sumOfScores = 0;

  reviews.map((review) => {
    const reviewStringValue = review.node.starRating;
    sumOfScores += wordToNumber[reviewStringValue];
    return (sumOfScores)
  })

  const averageRating = Math.round(sumOfScores / reviewsCount * 10) / 10;

  return (
    <div className="google-rating">
      <a href="/about-us/reviews/" target="_blank" className="rating-link">
        <div>
          {review == 'true' && <img src={GoogleReviewsColor} alt="Google Reviews Bentley Hurst" /> }
          {review != 'true' && <img src={GoogleReviews} alt="Google Reviews Bentley Hurst" />}
        </div>
        <p>
          <span className={`${revclass} d-block d-lg-none`}> <strong>{rating_avg ? parseFloat(rating_avg.toFixed(1)) : '4.8'}/5</strong> from {testimonial_count ? testimonial_count+'+' : '385+'} Reviews</span>
          <span className={`${revclass}  d-none d-lg-block`}> <strong>{rating_avg ? parseFloat(rating_avg.toFixed(1)) : '4.8'}/5</strong> from {testimonial_count ? testimonial_count+'+' : '385+'} Customer Reviews</span>
        </p>
      </a>
    </div>
  )
}
export default GoogleRating
